import { useState } from "react";
import { findLast, get } from "lodash";

export const useSummaryCheck = (cards) => {
  const [showSummary, setShowSummary] = useState(false);
  let summaryPresent = false;
  let summaryIndex = "none";

  if (Array.isArray(cards) && cards.length) {
    const summaryCard = findLast(cards, (card) => {
      const elements = get(card, ["story-elements"], []);
      return elements.some((element) => element?.subtype === "summary");
    });

    if (summaryCard) {
      const summaryElementIndex = get(summaryCard, ["story-elements"], []).findIndex(
        (element) => element?.subtype === "summary"
      );
      const summaryElements = get(summaryCard, ["story-elements"], []);

      summaryPresent = summaryElementIndex >= 0;

      if (summaryPresent) {
        summaryIndex = summaryElementIndex === summaryElements.length - 1 ? "last" : "beforeLast";
      }
    }
  }

  return { summaryPresent, showSummary, setShowSummary, summaryIndex };
};
